import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bccd6042"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cur-search-opt" }
const _hoisted_2 = { class: "search-content" }
const _hoisted_3 = { class: "action" }
const _hoisted_4 = {
  key: 0,
  class: "contents"
}
const _hoisted_5 = { class: "van-safe-area-bottom contents-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchItem = _resolveComponent("SearchItem")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_ContentsItem = _resolveComponent("ContentsItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_dropdown_menu, {
      class: "search-wrap",
      "active-color": "#4675F1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_dropdown_item, {
          ref: "refDropdownItem",
          onOpen: _ctx.handleDropdownOpen
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.submitSearchLabels.length ? _ctx.submitSearchLabels.join('·') : '-'), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchArrOptions, (item, i) => {
                return (_openBlock(), _createBlock(_component_SearchItem, {
                  data: item,
                  key: i,
                  index: i,
                  show: _ctx.subjectId == 3 ? true : i < 1 ? false : true,
                  title: item.label,
                  options: item.options,
                  value: _ctx.serachValues[i],
                  "onUpdate:value": ($event: any) => ((_ctx.serachValues[i]) = $event),
                  label: _ctx.searchLabels[i],
                  "onUpdate:label": ($event: any) => ((_ctx.searchLabels[i]) = $event),
                  onUpdateChild: _ctx.handleSetSearchChild
                }, null, 8, ["data", "index", "show", "title", "options", "value", "onUpdate:value", "label", "onUpdate:label", "onUpdateChild"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_van_button, {
                block: "",
                color: "#F6F6F6",
                style: {"color":"#4675f1"},
                onClick: _ctx.handleCloseSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_van_button, {
                block: "",
                type: "primary",
                color: "#4675f1",
                onClick: _ctx.handleSubmitSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onOpen"])
      ]),
      _: 1
    }),
    (_ctx.isShowPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.knowledge.length)
              ? (_openBlock(), _createBlock(_component_van_empty, {
                  key: 0,
                  description: "暂无数据",
                  image: require('@/assets/images/aio/wrong-data.png')
                }, null, 8, ["image"]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.knowledge, (item, i) => {
                  return (_openBlock(), _createBlock(_component_ContentsItem, {
                    item: item,
                    key: i,
                    onChange: _ctx.handleContentsItemOpen,
                    ref_for: true,
                    ref: "contentsItems"
                  }, null, 8, ["item", "onChange"]))
                }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}